// 表单验证插件vee-validate
'use strict';
import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN'//引入中文文件
import VueI18n from 'vue-i18n';
    Vue.use(VueI18n)
    const i18n = new VueI18n({
          locale: 'zh_CN',
    })
    Validator.localize('zh_CN')
    Vue.use(VeeValidate, {
          i18n,
          i18nRootKey: 'validation',
          dictionary: {
              zh_CN
          }
  });




// WEBPACK FOOTER //
// ./src/assets/js/validate.js